import React from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';

const StyledContainer = styled.div`
  .Toastify__toast {
    border-radius: 10px;
    box-shadow: 0 0 8px #00000022;
    margin: 15px;
    padding: 0;
  }
`;

export default function ToastConfig() {
  return (
    <StyledContainer>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton={false}
        transition={Slide}
      />
    </StyledContainer>
  );
}
